import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { routeLinks } from '../data/navigation';
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  const solid = !isHome || scrolled || open;
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-200 ease-out ${solid ? 'border-white/10 bg-navy/95 backdrop-blur' : 'border-transparent bg-transparent'}`} data-id="element-215" data-mp="zw0q15q9gnpy">
      <div className="mx-auto flex h-20 max-w-shell items-center justify-between gap-6 px-6 lg:px-8" data-id="element-216" data-mp="2bev1pb88emly">
        <Link to="/" className="flex flex-col leading-none" data-id="element-217" data-mp="29m6h56ibl0yy">
          <span className="font-serif text-base tracking-wide text-white sm:text-lg" data-id="element-218" data-mp="2ehbxlpsydnfn">
            GREGORY J. SLAVONIC
          </span>
          <span className="mt-1 text-[10px] font-medium uppercase tracking-overline text-gold-light" data-id="element-219" data-mp="2jg5abg0f1aer">
            Rear Admiral (Ret.)
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden xl:block" data-id="element-220" data-mp="1quvs6uw5my9p">
          <ul className="flex items-center gap-5" data-id="element-221" data-mp="1vrm559cnxdqw">
            {routeLinks.map(link => <li key={link.to} data-id="element-222" data-mp="20qypnng2a8qb">
                <NavLink to={link.to} end={link.to === '/'} className={({
              isActive
            }) => `relative block whitespace-nowrap py-1 text-[13px] font-medium transition-colors duration-150 ease-out ${isActive ? 'text-gold-light' : 'text-slate-300 hover:text-white'}`} data-id="element-223" data-mp="20pxezk2yjo94">
                  {({
                isActive
              }) => <>
                      {link.label}
                      {isActive && <span className="absolute -bottom-0.5 left-0 h-px w-full bg-gold" data-id="element-224" data-mp="1eqro3jks15v3" />}
                    </>}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-225" data-mp="m2vwgta2e456">
          <Link to="/contact" className="hidden whitespace-nowrap bg-gold px-5 py-2.5 text-[13px] font-semibold text-navy transition-colors duration-150 ease-out hover:bg-gold-light lg:inline-block" data-id="element-226" data-mp="h3ixja5x56m8">
            Request Board Bio
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-11 w-11 items-center justify-center border border-white/20 text-white transition-colors duration-150 ease-out hover:border-gold hover:text-gold-light xl:hidden" data-id="element-227" data-mp="r3tcp0biko41">
            {open ? <XIcon className="h-5 w-5" data-id="element-228" data-mp="2ewv9rmfy4xmj" /> : <MenuIcon className="h-5 w-5" data-id="element-229" data-mp="21088x8kvhnbc" />}
          </button>
        </div>
      </div>

      {open && <div className="max-h-[calc(100vh-5rem)] overflow-y-auto border-t border-white/10 bg-navy xl:hidden" data-id="element-230" data-mp="250a3yyw3rihn">
          <nav aria-label="Mobile" className="mx-auto max-w-shell px-6 py-4" data-id="element-231" data-mp="2srxkcmvqnb5o">
            <ul className="grid gap-x-8 sm:grid-cols-2" data-id="element-232" data-mp="2xpz3f7t5zah5">
              {routeLinks.map(link => <li key={link.to} className="border-b border-white/5" data-id="element-233" data-mp="2jz416ed67rmj">
                  <NavLink to={link.to} end={link.to === '/'} className={({
              isActive
            }) => `block py-3 text-sm font-medium ${isActive ? 'text-gold-light' : 'text-slate-200 hover:text-white'}`} data-id="element-234" data-mp="2nzwblaxs42ke">
                    {link.label}
                  </NavLink>
                </li>)}
            </ul>
            <Link to="/contact" className="mt-4 block bg-gold px-5 py-3 text-center text-sm font-semibold text-navy" data-id="element-235" data-mp="1nuvm73ff0lml">
              Request Board Bio / Inquiry
            </Link>
          </nav>
        </div>}
    </header>;
}